import React from 'react';
import {PaymentRegisterReviewComponent} from '../../components';

// Todo 支払い部分の統合
export const PaymentRegisterReview: React.FC = () => {
  return <PaymentRegisterReviewComponent />;
};
